import { FloatingFormItem } from '@/components/_common';
import InputDateWithInfo from '@/components/_common/InputDateWithInfo';
import Authorities from '@/types/Authority';
import { hasPermissions } from '@/utils/functions/hasPermissions';
import { useIntl } from 'react-intl';

interface EstimatedLeaveDateFieldProps {
  isAlwaysGenerateActivityByWorkOrder?: boolean;
}

export default function EstimatedLeaveDateField(
  props: EstimatedLeaveDateFieldProps,
) {
  const intl = useIntl();

  return (
    <FloatingFormItem
      name="estimatedLeaveDate"
      label={intl.formatMessage({
        id: 'workOrders.domain.complements.estimatedLeaveDate',
      })}
      rules={[
        {
          required:
            !hasPermissions([
              Authorities.MOVIMENTATION_WORKORDER_ALLOW_EMPTY_ESTIMATED_LEAVE_DATE,
            ]) || props?.isAlwaysGenerateActivityByWorkOrder,
        },
      ]}
    >
      <InputDateWithInfo
        inputDateProps={{ showTime: true }}
        tooltipProps={{
          title:
            'Preenchimento obrigatório, conforme configuração da empresa para gerar atividade automaticamente.',
        }}
        isViewInfo={props?.isAlwaysGenerateActivityByWorkOrder}
      />
    </FloatingFormItem>
  );
}
